export default __webpack_public_path__ + "static/media/slide3.28dc9e2b.jpg";